export const PhoneNumber = () => '(800) 710-1934';
export const PhoneNumberTell = () => "tel:1" + PhoneNumber().replace(/[^0-9]/g, '');
export const headline = () => 'California Live Scan Service';
export const paperEducationPolicyMessage = () => `Biometric Information Security Policy`
export const paperEducationLabel_1 = () => `I confirm that I have reviewed and signed the `
export const paperEducationLabel_2 = () => `through Paper.`
export const socialSecurityNumberLabel = (isRequired) => `Social Security Number ${isRequired ? '*' : ''}`;
export const requiredSSNLabel = () => `I don't have a Social Security number.`;